import { TablesUpdate } from "@/lib/supabase/supabase_types_override";
import { supabase } from "@/lib/supabase/supabaseClient";
import { WithRequired } from "@tanstack/react-query";

export const updateCrm = async (crm: WithRequired<TablesUpdate<'crm'>, 'id'>) => await supabase.from('crm').update(crm).eq('id', crm.id).throwOnError()